<template>
<div class="nav-total-content">
    <!-- 每一块的导航 -->
    <nav class="common-nav-content" id="jude-nav-content">
        <ul :style="getStyle">
        <li
            v-for="(item, index) in sonNavData.navArr"
            :key="index"
        >
            <a 
            :href="'#'+item.id"
            @click.prevent="toAnchorPoint(item.id)"
            >{{item.name}}
            </a>
        </li>
        </ul>
    </nav>

    <!-- 脱离文本流居顶的nav -->
    <transition name="fadeFast">
        <nav 
            v-show="sonNavData.showFixeNav"
            :class="['common-nav-content', 'nav-content-fixed']"
            id="nav-content-fixed"
        >
        <ul :style="getStyle">
            <li
            v-for="(item, index) in sonNavData.navArr"
            :key="index"
            >
            <a 
                :href="'#'+item.id"
                @click.prevent="toAnchorPoint(item.id)"
            >{{item.name}}
            </a>
            </li>
        </ul>
        </nav>
    </transition>
</div>

</template>

<script>
import $ from 'jquery';
export default {
    name: 'sonNav',
    props: {
        sonNavData: Object
    },
    computed: {
        getStyle() {
            let style = `width: ${this.sonNavData.ulWidth};`;
            
            if (innerWidth < 375 && innerWidth >= 360) {
                style = `width: ${innerWidth + 20}px`;
            } else if (innerWidth < 360 && innerWidth >= 320) {
                style = `width: ${innerWidth + 50}px`;
            }
            return style;
        }
    },

    created() {
        if (this.isAndroid()) {
            $('body').height('auto');
        }
    },

    data(){
        return {}
    },

    methods: {
        toAnchorPoint( id ) {
            // let ✌️ = lmc.include['💪'] + 🍀 ? ✌️ : null;
            let str = 'lmc';
            console.log(str.includes('l'))


            const 
            top = $(`#${id}`).offset().top + $("body").scrollTop(),
            parentObj = $(`#${id}`);


            if (!this.isAndroid()) {
                if (!$(parentObj).hasClass(this.sonNavData.aniClassName)) {
                    document.getElementsByTagName('body')[0].scrollTop = top - this.sonNavData.aniDistance;
                } else {
                    document.getElementsByTagName('body')[0].scrollTop = top;
                }
            } else {
                const top = $(`#${id}`).offset().top;

                if (!$(parentObj).hasClass(this.sonNavData.aniClassName)) {
                    document.scrollingElement.scrollTop = top - this.sonNavData.aniDistance;
                } else {
                    document.scrollingElement.scrollTop = top;
                }
            }
            
        },
        isAndroid(){
            var u = navigator.userAgent;
            if(u.indexOf('Android') > -1 || u.indexOf('Linux') > -1){
                return true;
            }
        }
    }
}
</script>
<style lang="less" scoped>
*{
    margin: 0;
    padding: 0;
}
li{
    list-style: none;
}
.common-nav-content{
    height: 54px;
    background: #FFFFFF;
    // box-shadow: 0px 0px 0px 0px #E1E1E1;
    // .allCenter;
    border-bottom: 1px solid #E1E1E1;
    overflow-x: auto;
    overflow-y: hidden;
    line-height: 54px;
    

    &.nav-content-fixed{
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999999;
        background: #fff;
    }


    ul{
        width: 102%;
        height: 100%;
        // .spaceBetweenX;
        padding: 0 5%;


        li{
            display: inline-block;
            text-align: center;
            width: auto;
            height: 22px;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #666;
            line-height: 22px;
            margin-left: 24px;
        
            &:first-child{
                margin-left: 0;
            }

            a{
                color: #666;
                font-family: PingFangSC-Regular, PingFang SC;
                &.active{
                    color: #222;
                    font-family: PingFangSC-Medium, PingFang SC;
                }
            }
        }
    }
}


@media screen and (min-width: 420px) {
    .common-nav-content{
        overflow: hidden;
    }
}
</style>
